import React, {useState} from 'react'
import { SlTabGroup, SlTab } from '@shoelace-style/shoelace/dist/react'
import CustomerwiseSales from './CustomerwiseSales'
import AgingReport from './AgingReport'
import SalesPersonWiseSales from './SalesPersonWiseSales'

function FinanceReports() {
      const [reportType, setReportType] = useState('customer')

    return (
      <>
      <h2 >Finance Reports</h2>
        <SlTabGroup className='my-2'>
            <SlTab slot="nav" onClick={() => setReportType('customer')}>Customer Reports</SlTab>
            <SlTab slot="nav" onClick={() => setReportType('aging')}>Aging Reports</SlTab>
            <SlTab slot="nav" onClick={() => {setReportType('sales')}}>Sales Reports</SlTab>
        </SlTabGroup>
    
        {reportType === 'customer' ? <CustomerwiseSales /> : reportType === 'aging' ? <AgingReport/> : <SalesPersonWiseSales />}
      </>
    )
}
export default FinanceReports